import React from 'react';
import { Alert, Snackbar } from '@mui/material';

type SnackbarErrorProps = {
  open: boolean;
  onClose: () => void;
  alertMessage: string;
};

export const SnackbarError = ({ open, onClose, alertMessage }: SnackbarErrorProps) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity="error" sx={{ width: '100%', fontSize: '16px' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};
